import { Component, OnInit } from '@angular/core';
import { MenuItemsService } from '../shared/services/menu-items/menu-items.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-area-page',
    templateUrl: './area-page.component.html',
    styleUrls: ['./area-page.component.scss']
})
export class AreaPageComponent implements OnInit {
    public checkedKeys: any[] = ["0_1"];
    subModules: any
    constructor(
        public menuItemsService: MenuItemsService,
        private route: ActivatedRoute,
        private router: Router,
        private translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(query => {
            this.subModules = this.menuItemsService.items.find(res => res.text && (res.text == query.module))?.children;
        });
    }

    onSelectionChange(event: any) {
        if (event.dataItem.path) {
            this.router.navigate([event.dataItem.path])
        }
    }

    navigateToPage(path: string) {
        this.router.navigate([path]);
    }
}
